import { IOption } from 'types/textValue';

export const sortOptions = (options: IOption[]): IOption[] => {
  return options.sort((a, b) => a?.id - b?.id);
};
